import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=8159d7c8&scoped=true"
import script from "./Loginpage.vue?vue&type=script&lang=js"
export * from "./Loginpage.vue?vue&type=script&lang=js"
import style0 from "./Loginpage.vue?vue&type=style&index=0&id=8159d7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8159d7c8",
  null
  
)

export default component.exports